import axios from '../utils/axios';

const API_PREFIX = '/api';

const getInterviews = async () => {
	const result = await axios.get(`${API_PREFIX}/interviews`);

	return result.data.data;
};

const createInterview = async (data) => {
	const result = await axios.post(`${API_PREFIX}/interviews`, data);

	return result.data.data;
};

const deleteInterview = async (interviewId) => {
	const result = await axios.delete(`${API_PREFIX}/interviews/${interviewId}`);

	return result.data.data;
};

const updateInterview = async (interviewId, payload) => {
	const result = await axios.put(`${API_PREFIX}/interviews/${interviewId}`, payload);

	return result.data.data;
};

const getInterview = async (interviewId) => {
	const result = await axios.get(`${API_PREFIX}/interviews/${interviewId}`);

	return result.data.data;
};

const getInterviewRound = async (roundId) => {
	const result = await axios.get(`${API_PREFIX}/interviews/round/${roundId}`);

	return result.data.data;
};

const updateQuestion = async (interviewId, questionId, video, audio, askedAt, answeredAt) => {
	return new Promise((resolve, reject) => {
		const formData = new FormData();

		formData.append('mediaVideo', video, 'video.webm');
		formData.append('mediaAudio', audio, 'audio.webm');
		formData.append('askedAt', askedAt);
		formData.append('answeredAt', answeredAt);
    
		axios.post(`${API_PREFIX}/interviews/${interviewId}/questions/${questionId}`, formData, {
			headers: { 
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data' 
			}
		}
		).then((response) => {
			resolve(response);
		}).catch((err) => {
			reject(err);
		});
	});
};

const retakeRound = async (roundId) => {
	const result = await axios.post(`${API_PREFIX}/interviews/round/${roundId}/retake`);

	return result.data.data;
};

const skipQuestion = async (interviewId, questionId) => {
	const result = await axios.post(`${API_PREFIX}/interviews/${interviewId}/questions/${questionId}/skip`);

	return result;
};

const createNextRound = async (interviewId, round) => {
	const result = await axios.post(`${API_PREFIX}/interviews/${interviewId}/round`, {
		round
	});

	return result.data.data;
};

// EN-1038's likely questions for a role, cached per title and company. `jd` is a Job Tracker row's
// uuid, whose Job Board posting shapes the questions.
const getLikelyQuestions = async ({ title, company, jd }) => {
	const result = await axios.get(`${API_PREFIX}/interview-ai/likely-questions`, { params: { title, company, jd } });

	return result.data.data.questions;
};

const exportObj = {
	getInterviews,
	createInterview,
	deleteInterview,
	updateInterview,
	getInterview,
	updateQuestion,
	skipQuestion,
	createNextRound,
	getInterviewRound,
	retakeRound,
	getLikelyQuestions
};

export default exportObj;